import { Icon } from '@natera/material/lib/icon'
import { Textfield } from '@natera/material/lib/textfield'
import { debounce } from 'lodash-es'
import { useCallback, useEffect, useState } from 'react'
import type { DocumentFilters } from '../../model'
import { useFilters } from '../../model'

const debouncedSetFilters = debounce(
  (setFilters: (newFilters: Partial<DocumentFilters>) => void, value: string) => {
    setFilters({ assetId: value })
  },
  500,
)

export function SearchField() {
  const { filters, setFilters } = useFilters()
  const [localSearchValue, setLocalSearchValue] = useState(filters.assetId)

  useEffect(() => {
    setLocalSearchValue(filters.assetId)
  }, [filters.assetId])

  const handleSearchChange = useCallback(
    (value: string) => {
      setLocalSearchValue(value)
      debouncedSetFilters(setFilters, value)
    },
    [setFilters],
  )

  return (
    <Textfield
      className="bg-surface-lowest hover:bg-action-hovered h-12 w-[240px]"
      leadIcon={
        <Icon
          className="text-content-high-emphasis absolute top-1/2 left-0 mr-3 ml-4 -translate-y-1/2"
          children="search"
        />
      }
      materialClearIcon="close"
      clearable
      onClear={() => handleSearchChange('')}
      placeholder="Asset ID"
      value={localSearchValue}
      onChange={(e) => handleSearchChange(e.target.value)}
      outline
    />
  )
}
